import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { filter, map } from "rxjs";
import { pagePermissions } from "../../access-control/page-permissions/page-permissions.selectors";
import { AccessControlRequirements, hasPageAccess } from "../../access-control/access-control";
import { Configuration, configurationToken } from "../../../configuration";
import { getFeatureFlags } from "../../access-control/feature-flags/feature-flags";
import { resolveLandingPageUrl } from "../landing-page/resolve-landing-page-url";
import { NavigationMenuService } from "../../navigation/navigation-menu.service";

export const pageAccessGuard = (requirements: AccessControlRequirements): CanActivateFn => {
    return (_route, state) => {
        const globalStore = inject(Store);
        const router = inject(Router);
        const navigationMenuService = inject(NavigationMenuService);

        const pagePermissions$ = globalStore.select(pagePermissions);
        const featureFlags = requirements.requiredFeatureFlags?.length
            ? getFeatureFlags(inject<Configuration>(configurationToken))
            : {};

        return pagePermissions$.pipe(
            filter((pagePermissions) => pagePermissions !== undefined),
            map((pagePermissions) => {
                if (!pagePermissions) {
                    return false;
                }

                const accessControlContext = { pagePermissions, featureFlags };
                if (hasPageAccess({ requirements, context: accessControlContext })) {
                    return true;
                }

                // Redirect the user when denied access to their landing page.
                const landingPageUrl = resolveLandingPageUrl(navigationMenuService.userNavigationMenu(), router);
                return router.serializeUrl(landingPageUrl) === state.url ? false : landingPageUrl;
            }),
        );
    };
};
